import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Vertical/horizontal step indicator for multi-step booking flow.
 */
export const BookingStepIndicator = ({ steps, currentStep }) => {
  return (
    <div className="w-full">
      {/* Mobile: compact text indicator */}
      <div className="md:hidden flex items-center justify-between mb-4 px-1">
        <span className="text-xs uppercase tracking-wider text-muted-foreground">
          Step {currentStep + 1} di {steps.length}
        </span>
        <span className="text-xs font-semibold text-primary">{steps[currentStep]?.label}</span>
      </div>
      <div className="md:hidden h-1.5 bg-muted rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-primary to-primary/70 transition-all duration-500"
          style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }}
        />
      </div>

      {/* Desktop: full stepper */}
      <ol className="hidden md:flex items-start justify-between gap-2 w-full">
        {steps.map((step, idx) => {
          const isActive = idx === currentStep;
          const isComplete = idx < currentStep;
          return (
            <li key={step.id} className="flex-1 flex flex-col items-center text-center relative">
              {/* Connector line */}
              {idx < steps.length - 1 && (
                <div className={cn(
                  "absolute top-4 left-1/2 w-full h-0.5 -z-0",
                  isComplete ? "bg-primary" : "bg-border"
                )} style={{ transform: "translateX(50%)" }} />
              )}
              <div
                data-testid={`booking-step-${step.id}`}
                className={cn(
                  "relative z-10 flex h-9 w-9 items-center justify-center rounded-full border-2 font-semibold text-sm transition-all",
                  isActive && "border-primary bg-primary text-primary-foreground shadow-md scale-110",
                  isComplete && "border-primary bg-primary text-primary-foreground",
                  !isActive && !isComplete && "border-border bg-background text-muted-foreground"
                )}
              >
                {isComplete ? <Check className="h-4 w-4" /> : idx + 1}
              </div>
              <span className={cn(
                "mt-2 text-xs leading-tight max-w-[120px]",
                isActive ? "font-semibold text-foreground" : "text-muted-foreground"
              )}>
                {step.label}
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default BookingStepIndicator;
